import { Injectable, OnDestroy } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@nrwl/angular';

import * as ProjectActions from './projects.actions';
import { catchError, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { ProjectInterface, ProjectInterfaceWithId } from '@sk/sk-interfaces';
import { ProjectService } from 'services/project.service';



@Injectable()
export class ProjectsEffects implements OnDestroy{
  unsubscribe$ = new Subject();


  queryProjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectActions.queryFireStoreProjects),
      takeUntil(this.unsubscribe$),
      switchMap(() => this.projectService.queryStateChangesProjects()),
      mergeMap(actions => actions),
      map(action => {
        if (action.payload.doc.exists) {
          const payload = {
            ...action.payload.doc.data() as ProjectInterface,
            id: (action.payload.doc.id) ? action.payload.doc.id : null,
            exists: action.payload.doc.exists
          } as ProjectInterfaceWithId;
          // FireStore Events:  'added' | 'removed' | 'modified'
          switch (action.type) {
            case 'added':
              return ProjectActions.fromFireStoreAddProject({ project: payload });
              break;
            case 'removed':
              return ProjectActions.fromFireStoreRemoveProject({ id: payload.id });
              break;
            case 'modified':
              return ProjectActions.fromFireStoreModifyProject({
                project: payload
              });
              break;
          }
        }
      }),
      catchError((error) => {
        return of(ProjectActions.queryFireStoreProjectsError({
          error
        }));
      })
    )
  );


  updateProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectActions.updateProject),
      switchMap(action => {
        console.log(action)
        return this.projectService.updateProjectByIdWithNGRX(action.changes, action.id);
      }),
      map(() => ProjectActions.updateProjectSuccess({})
      ),
      catchError((error) => {
        return of(ProjectActions.updateProjectsError({
          error
        }));
      })
    )
  );


  addProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectActions.addProject),
      switchMap(action => {
        console.log('ADD', action);
        return this.projectService.addProjectByNgrx(action.project);
      }),
      map(() => ProjectActions.addProjectSuccess({})),
      catchError((err: Error) => {
        console.error(err);
        if (err) {
          return of(ProjectActions.addProjectError({ error: err }));
        }
      })
    )
  );


  constructor(private actions$: Actions,
              private projectService: ProjectService) {
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
